var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"logo-container",attrs:{"md":"1"}},[(_vm.projectEvent.company)?_c('img',{staticClass:"logo",attrs:{"src":_vm.projectEvent.company.logoUrl,"alt":_vm.projectEvent.company.name}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }